/**
 * Created by pmnia on 02/03/15.
 */
(function () {
    'use strict';

    angular
        .module('app.data', ['app.core']);
})();



/*****************
 ** WEBPACK FOOTER
 ** ./app/data/data.module.js
 ** module id = 159
 ** module chunks = 0
 **/